import { PolicyRule } from '../interfaces/policyRule';
import { BaseAuthenticationResource } from './BaseAuthenticationResource';

export class PolicyRuleResource extends BaseAuthenticationResource implements PolicyRule {
  readonly policyRuleId: number = 0;
  readonly name: string = '';
  readonly description: string = '';
  readonly expression1: string = '';
  readonly expression2: string = '';
  readonly expression3: string = '';
  readonly message: string = '';
  readonly criteria: string = '';
  readonly active: boolean = false;
  readonly changedBy?: string = '';
  readonly changedDate?: Date = undefined;
  readonly sortOrder?: number = undefined;
  readonly hidden: boolean = false;

  pk() {
    return `${this.policyRuleId}`;
  }

  static urlRoot = '/api/policyrules/';
}
